import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "d-flex align-start",
  style: {"gap":"8px"}
}
const _hoisted_3 = {
  key: 0,
  class: "text-caption text--secondary mb-2",
  style: {"margin-top":"-8px"}
}
const _hoisted_4 = { class: "text-caption text--secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.modalShow,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalShow) = $event)),
    width: "800",
    persistent: ""
  }, {
    default: _withCtx(() => [
      (_ctx.exportAreasDialog && _ctx.model)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { "primary-title": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("message.exportAreasDialogTitle")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.exportAreasInformation")), 1),
                  _createVNode(_component_v_select, {
                    variant: "outlined",
                    density: "compact",
                    modelValue: _ctx.areaSetId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.areaSetId) = $event)),
                    items: _ctx.areaSetItems,
                    "item-title": "title",
                    "item-value": "id",
                    label: _ctx.$t('message.exportAreasAreaSet'),
                    "prepend-icon": "mdi-map-outline",
                    rules: [_ctx.requiredRule]
                  }, null, 8, ["modelValue", "items", "label", "rules"]),
                  (_ctx.areaSetId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_list_subheader, { class: "pl-0" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("message.exportAreasFilters")), 1)
                          ]),
                          _: 1
                        }),
                        (!_ctx.loadingProperties && _ctx.propertyItems.length === 0)
                          ? (_openBlock(), _createBlock(_component_v_alert, {
                              key: 0,
                              type: "info",
                              density: "compact",
                              variant: "outlined"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.exportAreasNoNumericProperties")), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'f' + idx
                          }, [
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_component_v_select, {
                                variant: "outlined",
                                density: "compact",
                                modelValue: filter.areaPropertyName,
                                "onUpdate:modelValue": ($event: any) => ((filter.areaPropertyName) = $event),
                                items: _ctx.propertyItems,
                                "item-title": "title",
                                "item-value": "name",
                                label: _ctx.$t('message.exportAreasProperty'),
                                style: {"flex":"2"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "label"]),
                              _createVNode(_component_v_text_field, {
                                variant: "outlined",
                                density: "compact",
                                modelValue: filter.minValue,
                                "onUpdate:modelValue": ($event: any) => ((filter.minValue) = $event),
                                modelModifiers: { number: true },
                                type: "number",
                                label: _ctx.$t('message.exportAreasMinValue'),
                                placeholder: _ctx.propertyMinPlaceholder(filter.areaPropertyName),
                                "persistent-placeholder": "",
                                style: {"flex":"1"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"]),
                              _createVNode(_component_v_text_field, {
                                variant: "outlined",
                                density: "compact",
                                modelValue: filter.maxValue,
                                "onUpdate:modelValue": ($event: any) => ((filter.maxValue) = $event),
                                modelModifiers: { number: true },
                                type: "number",
                                label: _ctx.$t('message.exportAreasMaxValue'),
                                placeholder: _ctx.propertyMaxPlaceholder(filter.areaPropertyName),
                                "persistent-placeholder": "",
                                style: {"flex":"1"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "placeholder"]),
                              _createVNode(_component_v_btn, {
                                icon: "",
                                variant: "text",
                                onClick: ($event: any) => (_ctx.removeFilter(idx)),
                                title: _ctx.$t('message.exportAreasRemoveFilter')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                      _createTextVNode("mdi-delete-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick", "title"])
                            ]),
                            (_ctx.rangeHint(filter.areaPropertyName))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.rangeHint(filter.areaPropertyName)), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          size: "small",
                          color: "primary",
                          onClick: _ctx.addFilter,
                          disabled: _ctx.propertyItems.length === 0
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-plus", -1)
                              ]))]),
                              _: 1
                            }),
                            _createTextVNode(_toDisplayString(_ctx.$t("message.exportAreasAddFilter")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_switch, {
                    modelValue: _ctx.includeValues,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.includeValues) = $event)),
                    density: "compact",
                    "hide-details": "",
                    class: "mt-4",
                    label: _ctx.$t('message.exportAreasIncludeValues')
                  }, null, 8, ["modelValue", "label"]),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("message.exportAreasIncludeValuesHint")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    disabled: _ctx.areaSetId == null,
                    onClick: _ctx.submit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { left: "" }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-download", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t("message.exportAreasButton")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _ctx.close
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}